import { jsx as e } from "react/jsx-runtime";
import i from "./TryDemo.js";
import c from "../../assets/icons/dynamic-pricing.svg.js";
import g from "../../assets/icons/market-finder.svg.js";
import u from "../../assets/icons/mash-board.svg.js";
import b from "../../assets/icons/home-line.svg.js";
import k from "../../assets/icons/calendar-icon.svg.js";
var _ = function _(_ref) {
  var a = _ref.onDemoClick,
    _ref$baseOrigin = _ref.baseOrigin,
    t = _ref$baseOrigin === void 0 ? "" : _ref$baseOrigin,
    o = _ref.eventHandler;
  var n = function n() {
      a == null || a(), o({
        category: "main",
        action: "GetDemo"
      });
    },
    r = {
      mainLink: "".concat(t, "/product"),
      linksSection: [{
        title: "Product Features",
        isMergeOnMb: !0,
        links: [{
          text: "Airbnb Data",
          url: "".concat(t, "/airbnb-data"),
          onClick: function onClick() {
            return o({
              category: "product",
              action: "AirbnbData"
            });
          },
          logo: /* @__PURE__ */e(c, {})
        }, {
          text: "Vacation Rentals for Sale",
          url: "".concat(t, "/airbnb-for-sale"),
          onClick: function onClick() {
            return o({
              category: "product",
              action: "AirbnbSale"
            });
          },
          logo: /* @__PURE__ */e(g, {})
        }, {
          text: "Vacation Rental Software",
          url: "".concat(t, "/vacation-rental-software"),
          onClick: function onClick() {
            return o({
              category: "product",
              action: "VacationRentalSoftware"
            });
          },
          logo: /* @__PURE__ */e(k, {
            width: 28,
            height: 28
          })
        }]
      }, {
        title: "",
        links: [{
          text: "Airbnb Calculator",
          url: "".concat(t, "/airbnb-calculator"),
          onClick: function onClick() {
            return o({
              category: "product",
              action: "AirbnbCalculator"
            });
          },
          logo: /* @__PURE__ */e(u, {})
        }, {
          text: "Property marketplace",
          url: "".concat(t, "/product/marketplace"),
          onClick: function onClick() {
            return o({
              category: "product",
              action: "MarketPlace"
            });
          },
          logo: /* @__PURE__ */e(b, {})
        }, {
          text: /* @__PURE__ */e(i, {}),
          onClick: n,
          as: "button"
        }]
      }]
    },
    s = {
      mainLink: "".concat(t, "/blog/"),
      linksSection: [{
        title: "Resources",
        links: [{
          text: "Blog",
          url: "".concat(t, "/blog/"),
          target: "_blank",
          onClick: function onClick() {
            return o({
              category: "resources",
              action: "Blog"
            });
          }
        }, {
          text: "Real Estate Investing Guide",
          url: "".concat(t, "/blog/real-estate-investing-guide/"),
          target: "_blank",
          onClick: function onClick() {
            return o({
              category: "resources",
              action: "RealEstateInvesting"
            });
          }
        }, {
          text: "Vacation Rental Guide",
          url: "".concat(t, "/blog/vacation-rental-guide/"),
          target: "_blank",
          onClick: function onClick() {
            return o({
              category: "resources",
              action: "VacationRental"
            });
          }
        }, {
          text: "Best Airbnb Markets",
          url: "".concat(t, "/blog/best-cities-for-airbnb/"),
          target: "_blank",
          onClick: function onClick() {
            return o({
              category: "resources",
              action: "AirbnbMarkets"
            });
          }
        }, {
          text: "Investor Resource Center",
          url: "".concat(t, "/blog/investor-tools/"),
          target: "_blank",
          onClick: function onClick() {
            return o({
              category: "resources",
              action: "InvestmentTools"
            });
          }
        }, {
          text: "Compare",
          url: "".concat(t, "/blog/airdna-alternatives/"),
          target: "_blank",
          onClick: function onClick() {
            return o({
              category: "resources",
              action: "Compare"
            });
          }
        }, {
          text: "Property Management",
          url: "".concat(t, "/blog/property-management/"),
          target: "_blank",
          onClick: function onClick() {
            o({
              category: "resources",
              action: "PropertyManagement"
            });
          }
        }, {
          text: "Airbnb Management",
          url: "".concat(t, "/blog/airbnb-management/"),
          target: "_blank",
          onClick: function onClick() {
            o({
              category: "resources",
              action: "AirbnbManagement"
            });
          }
        }, {
          text: "Financing",
          url: "".concat(t, "/blog/best-loans-for-investment-property/"),
          target: "_blank",
          onClick: function onClick() {
            o({
              category: "resources",
              action: "Financing"
            });
          }
        }, {
          text: "Glossary",
          url: "".concat(t, "/blog/real-estate-investing-terms/"),
          target: "_blank",
          onClick: function onClick() {
            o({
              category: "resources",
              action: "Glossary"
            });
          }
        }]
      }]
    },
    l = {
      mainLink: "",
      linksSection: [{
        title: "Guides",
        links: [{
          text: "Investing",
          subLinks: [{
            text: "7 Best Investment Software for Real Estate Investors",
            url: "".concat(t, "/blog/investment-software/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "How to Get Access to the MLS Database Without a License",
            url: "".concat(t, "/blog/get-access-mls-database-without-license/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "Airbnb Arbitrage: The Complete Guide for 2024",
            url: "".concat(t, "/blog/airbnb-rental-arbitrage/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "The Top 10 PropStream Competitors & Alternatives",
            url: "".concat(t, "/blog/propstream-competitors/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "Rental Comps: What Are They and Where Can I Find Them?",
            url: "".concat(t, "/blog/rental-comps/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "What is Cash on Cash Return",
            url: "".concat(t, "/blog/cash-on-cash-return/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "Mashvisor’s Rental Property Calculator: A Guide for Beginner Real Estate Investors",
            url: "".concat(t, "/blog/rental-property-calculator/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }, {
            text: "The Best Real Estate Competitive Market Analysis Software for 2024",
            url: "".concat(t, "/blog/competitive-market-analysis-software/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Investing"
              });
            }
          }]
        }, {
          text: "Hosting",
          subLinks: [{
            text: "How to Start an Airbnb Business in 10 Steps",
            url: "".concat(t, "/blog/how-start-airbnb-business/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "5 Steps to Conducting an Accurate Rental Market Analysis",
            url: "".concat(t, "/blog/5-steps-rental-market-analysis/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "How to Buy an Airbnb Investment Property",
            url: "".concat(t, "/blog/buy-airbnb-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "Airbnb Property Management Fees Breakdown – Are They Worth It?",
            url: "".concat(t, "/blog/airbnb-property-management-fees-worth-it/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "How to Find Out Who Owns a House in 6 Steps",
            url: "".concat(t, "/blog/how-to-find-out-who-owns-a-house/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "A Guide to Financing Airbnb Properties",
            url: "".concat(t, "/blog/financing-airbnb-properties/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "Airbnb Insurance: What Hosts Need to Know",
            url: "".concat(t, "/blog/airbnb-insurance/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }, {
            text: "Is Airbnb Profitable in 2024?",
            url: "".concat(t, "/blog/is-airbnb-profitable/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "Hosting"
              });
            }
          }]
        }, {
          text: "Investor tools",
          subLinks: [{
            text: "What Is the Best Rentometer Alternative in 2024?",
            url: "".concat(t, "/blog/rentometer-alternative/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "The Best Cap Rate Calculator in 2024",
            url: "".concat(t, "/blog/cap-rate-calculator/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "What’s the Best Rental App for Real Estate Investors?",
            url: "".concat(t, "/blog/best-rental-app/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "Top Real Estate Deal Analyzer Tool in 2022",
            url: "".concat(t, "/blog/real-estate-deal-analyzer/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "Want an Accurate Rent Estimate? Landlords Use This Calculator",
            url: "".concat(t, "/blog/rent-estimate/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "7 Best Real Estate Investing Apps for 2024",
            url: "".concat(t, "/blog/best-real-estate-investing-apps/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "Top 5 Websites to Analyze Investment Property",
            url: "".concat(t, "/blog/websites-to-analyze-investment-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "How to Find Owner Financed Homes for Investment",
            url: "".concat(t, "/blog/how-to-find-owner-financed-homes/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "8 Best Websites to Find Investment Property",
            url: "".concat(t, "/blog/websites-to-find-investment-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "The Best Comparative Market Analysis Tools for Beginner Investors",
            url: "".concat(t, "/blog/comparative-market-analysis-tools/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }, {
            text: "Mashvisor vs. AirDNA: What’s the Best Airbnb Analyzer?",
            url: "".concat(t, "/blog/mashvisor-vs-airdna/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestorTools"
              });
            }
          }]
        }, {
          text: "Investment Analysis",
          subLinks: [{
            text: "Buying Rental Property: 35 Expert Tips for Beginners",
            url: "".concat(t, "/blog/buying-rental-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "How to Determine Rental Demand Before Buying an Investment Property",
            url: "".concat(t, "/blog/determine-rental-demand-buying/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "How to Find Rental Property for Sale Using AI",
            url: "".concat(t, "/blog/find-rental-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "What Is The Ideal Rate Of Return On A Rental Property?",
            url: "".concat(t, "/blog/rate-of-return-on-rental-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "Are Condos a Good Investment in 2024? Pros & Cons Explained",
            url: "".concat(t, "/blog/condos-good-investment/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "Is a Real Estate Investment a Good Idea in 2024?",
            url: "".concat(t, "/blog/real-estate-investment/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "The Most Profitable Types of Real Estate Investment for 2024",
            url: "".concat(t, "/blog/types-of-real-estate-investment/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "11 Ways to Find Real Estate Investment Properties",
            url: "".concat(t, "/blog/ways-to-find-real-estate-investment-properties/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "What Cap Rate by City Can You Expect as a Real Estate Investor in 2024?",
            url: "".concat(t, "/blog/cap-rate-by-city/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "2024 Real Estate Market Forecast: Top 10 Predictions",
            url: "".concat(t, "/blog/real-estate-market/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "How to Perform a Real Estate Market Analysis",
            url: "".concat(t, "/blog/real-estate-market-analysis/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }, {
            text: "How to Find Cap Rate for a Real Estate Market",
            url: "".concat(t, "/blog/cap-rate/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "InvestmentAnalysis"
              });
            }
          }]
        }, {
          text: "Airbnb Investment Analysis",
          subLinks: [{
            text: "100 Best Cities for Airbnb Rental Income in 2024",
            url: "".concat(t, "/blog/best-cities-for-airbnb/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "How to Find Out the Airbnb Demand in My Area",
            url: "".concat(t, "/blog/airbnb-demand-in-my-area/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "100 Best Short Term Rental Markets in 2024",
            url: "".concat(t, "/blog/best-short-term-rental-markets/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "Where to Find Airbnb Statistics for Your Investment Property",
            url: "".concat(t, "/blog/airbnb-statistics-for-investment-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "Airbnb Property Analysis: Find Out if You’ll Turn a Profit in 10 Easy Steps",
            url: "".concat(t, "/blog/airbnb-property-analysis/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "Should You Buy a Vacation Rental Property in 2024?",
            url: "".concat(t, "/blog/vacation-rental-guide/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "How to Calculate ARV in Real Estate",
            url: "".concat(t, "/blog/arv-real-estate/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "20 Cities With No Airbnb Regulation in 2024",
            url: "".concat(t, "/blog/cities-no-airbnb-legal-issues/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "How to Buy an Airbnb Investment Property",
            url: "".concat(t, "/blog/buy-airbnb-property/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }, {
            text: "Airbnb Pricing: How Much to Charge for Rent",
            url: "".concat(t, "/blog/airbnb-pricing/"),
            target: "_blank",
            onClick: function onClick() {
              return o({
                category: "guides",
                action: "AirbnbInvestment"
              });
            }
          }]
        }]
      }]
    };
  return {
    productOverview: r,
    resources: s,
    guides: l
  };
};
export { _ as createMenuContentData };